<template>
    <div>
        <base-header type="primary" class="pb-6 pb-8 pt-5 pt-md-8">
        </base-header>

        <div class="container-fluid pt-4">
            <div class="row">
                <b-table id="table"
                         :items="list"
                         :fields="fields"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         :per-page="quantityPerPage"
                         :current-page="currentPage"
                         responsive
                         fixed
                         striped
                         show-empty>
                    <template #cell(id)="cell">
                        <router-link :to="{ name: 'task update', params: { id: cell.item.id } }" :class="'font-weight-normal text-uppercase text-'+cell.item.badge">
                            {{cell.item.id}}
                        </router-link>
                    </template>
                    <template #cell(status)="cell">
                        <span :class="'badge badge-dot mr-4 badge-'+cell.item.badge"><i :class="'bg-'+cell.item.badge"></i><span class="status">{{cell.item.status}}</span></span>
                    </template>
                    <template #cell(actions)="cell">
                        <div class="align-middle d-flex justify-content-start">
                            <router-link :to="{ name: 'task update', params: { id: cell.item.id } }"
                                         class=" btn btn-sm btn-primary btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-pencil-alt"></i>
                            </router-link>
                            <button @click="deleteForm(cell.item.id)" type="button"
                                    class=" btn btn-sm btn-danger btn-icon-only rounded-circle mt-1">
                                <i class="fa fa-trash"></i>
                            </button>
                        </div>
                    </template>

                </b-table>

                <b-pagination v-model="currentPage"
                              :total-rows="getTableItemsCount"
                              :per-page="quantityPerPage"
                              aria-controls="table">
                </b-pagination>
            </div>
        </div>

    </div>
</template>

<script>

    window.$ = window.jQuery = require('jquery');
    import firebase from '../config/db.js';
    import moment from 'moment'
    import swal from 'sweetalert2'
    import Vue from "vue";
    import { TablePlugin } from 'bootstrap-vue';
    Vue.use(TablePlugin);
    import { PaginationPlugin } from 'bootstrap-vue';
    Vue.use(PaginationPlugin);

    export default {
        name: 'policies',
        data() {
            return {
                list: [],
                fields: [
                    { key: 'id', sortable: true, label: 'Document ID' },
                    { key: 'status', sortable: true, label: 'Status' },
                    { key: 'created', sortable: true, label: 'Created', formatter: 'dateToString' },
                    { key: 'fromDateTime', sortable: true, label: 'From date', formatter: 'dateToString' },
                    { key: 'actions', sortable: false, label: 'Actions' },
                ],
                sortBy: 'created',
                sortDesc: true,
                quantityPerPage: 10,
                currentPage: 1,
                publicPath: process.env.BASE_URL,
            }
        },
        mounted: function () {
            this.getFormList();
        },
        methods: {
            getFormList: function () {
                var collection = [];
                firebase.firestore().collection("policies").orderBy("created", 'desc').get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        let statusText = '';
                        let badge = '';
                        if (doc.data().status == 'request') {
                            statusText = 'New request';
                            badge = 'dark';
                        } else if (doc.data().status == 'processing') {
                            statusText = 'Processing';
                            badge = 'default';
                        } else if (doc.data().status == 'payment_pending') {
                            statusText = 'Payment pending';
                            badge = 'info';
                        } else if (doc.data().status == 'in_force') {
                            statusText = 'In force';
                            badge = 'success';
                        } else if (doc.data().status == 'expired') {
                            statusText = 'Expired';
                            badge = 'dark';
                        } else {
                            statusText = 'Unknown';
                            badge = 'info';
                        }
                        collection.push({
                            id: doc.id,
                            status: statusText,
                            badge: badge,
                            created:doc.data().created.toDate(),
                            fromDateTime: doc.data().fromDateTime.toDate(),
                        });
                    });
                });
                this.list = collection;
            },
            deleteForm: function (data_key) {
                var that = this;

                swal.fire({
                    title: "Are you sure?",
                    text: "You won't be able to revert this!",
                    type: "warning",
                    showCancelButton: !0,
                    icon: 'warning',
                    confirmButtonColor: "#0CC27E",
                    cancelButtonColor: "#FF586B",
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, cancel!",
                    confirmButtonClass: "btn btn-success mr-5",
                    cancelButtonClass: "btn btn-danger",
                    buttonsStyling: !1
                }).then((result) => {
                    if (result.value) {
                        firebase.firestore().collection("policies").doc(data_key).delete().then(function () {
                            swal.fire({
                                text: "Policy deleted successfully...",
                                type: "success",
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 1500
                            });
                            that.getFormList();
                        }).catch(function (error) {
                            swal({
                                text: error,
                                type: "error",
                                showConfirmButton: false,
                                timer: 1500
                            });
                        });
                    }
                });
            },
            dateToString: function (value) {
                if (!value || typeof value === 'undefined') {
                    return "N/A";
                } else if (value instanceof Date) {
                    return moment(value).format('MMMM Do YYYY, h:mm:ss A');
                }
                return "N/A";
            }
        },
        computed: {
            getTableItemsCount() {
                return this.list.length;
            }
        }
    };
</script>

